<template>
    <div>
        <!--底部-->
        <ul class="footer">
            <router-link tag="li" to="/">
                <img src="~@public/img/global/home.png"/>
                <p>首页</p>
            </router-link>
            <li>
                <img src="~@public/img/global/map.png"/>
                <p>警务地图</p>
            </li>
            <li>
                <a href="http://www.gzga.gov.cn/index.html?name=jwgk">
                    <img src="~@public/img/global/content.png"/>
                    <p>警务公开</p>
                </a>
            </li>
            <router-link to="/login" tag="li" v-if="!$store.state.loginStatus">
                <img src="~@public/img/global/user.png"/>
                <p>登录</p>
            </router-link>
            <router-link to="/userCenter" tag="li" v-else>
                <img src="~@public/img/global/user.png"/>
                <p>个人中心</p>
            </router-link>
        </ul>
    </div>
</template>

<script>
    /**
     * Description: 底部的工具栏
     * Author: Wangyan
     * Date: 2019-02-28
     * Time: 09:49
     */

    export default {
        name: "Floor",
        data() {
            return {}
        }
    }
</script>

<style lang="less" scoped>
    .footer {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 2;

        li {
            width: 25%;
            height: 100%;
            float: left;
            background: #fff;
            font-size: .25rem;
            text-align: center;
            padding: 3px 0;
            color: black;
        }

        img {
            width: 0.6rem;
            vertical-align: middle;
        }

        p {
            font-size: 0.35rem;
        }
    }
</style>
